export const isEmployed = (employmentStatus) => {
    return ['Employed', 'Self-Employed'].includes(employmentStatus);
};